import { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { API_URL, isFieldError } from "../../../helpers";

import Select from "../../../components/Select";
import Input from "../../../components/Input";
import Msg from "../../../components/Msg";
import Submit from "../../../components/Submit";

import ThDayHdg from "./ThDayHdg";
import TdDayVal2 from "./TdDayVal2";

const HotelEditForm = ({ details, token }) => {
	const [names, setNames] = useState({
		status: details.status,
		newStatus: details.status,
		inProcess: details.inProcess,
		confirmation: details.confirmation,
		bed: details.bed,
		name: details.name,
		email: details.email,
		notes: details.notes,
	});
	const [errors, setErrors] = useState([]);
	const [msg, setMsg] = useState({});

	const history = useHistory();
	const formElement = useRef();

	const handleUpdate = (name, value) => {
		if (name === "newStatus") {
			setNames((names) => ({ ...names, [name]: parseInt(value, 10) }));
		} else {
			setNames((names) => ({ ...names, [name]: value ? value : "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		let url;
		let formData;

		if (names.newStatus === 3) {
			url = new URL(`${API_URL}/admin/hotelEditPartial`);
			formData = new FormData(formElement.current);
		} else {
			url = new URL(`${API_URL}/admin/hotelEdit`);
			formData = new FormData();
			Object.entries(names).forEach(([key, value]) => {
				if (key === "status" || key === "newStatus") {
				} else {
					formData.append(key, value);
				}
			});
			formData.append(
				"status",
				names.inProcess ? names.status : names.newStatus,
			);
		}
		formData.append(
			"sendEmail",
			names.sendEmail && details.status !== names.newStatus ? "1" : "0",
		);
		formData.append("roomId", details.roomId);
		formData.append("token", token);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				history.push({
					pathname: `/admin/hotel`,
					state: {
						message: {
							type: "success",
							text: json.text,
						},
					},
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<form
			ref={formElement}
			method="post"
			action="/"
			onSubmit={(e) => handleSubmit(e)}
			className="well"
			style={{ marginTop: "10px" }}
		>
			<h4
				style={{
					marginTop: "0",
					lineHeight: "22px",
					marginBottom: "10px",
					fontSize: "1.1rem",
				}}
			>
				Manage a Room Request ID {details.roomId}
			</h4>

			<div className="form-group">
				{names.inProcess ? (
					<Select
						name="none"
						label="Status"
						reqd={true}
						value={""}
						options={[{ id: "", name: "In Process" }]}
						update={handleUpdate}
						error={isFieldError(errors, "none")}
						disabled={true}
					/>
				) : (
					<Select
						name="newStatus"
						label="Status"
						reqd={true}
						value={names.status}
						options={
							names.status === 2
								? [
										{ id: "1", name: "Approved" },
										{ id: "3", name: "Partially Approve" },
										{ id: "2", name: "Pending" },
										{ id: "0", name: "Unavailable" },
								  ]
								: [
										{ id: "1", name: "Approved" },
										{ id: "2", name: "Pending" },
										{ id: "0", name: "Unavailable" },
								  ]
						}
						update={handleUpdate}
						error={isFieldError(errors, "newStatus")}
						disabled={false}
					/>
				)}

				{names.status === 1 || names.newStatus === 1 ? (
					<Input
						name="confirmation"
						label="Confirmation Number"
						reqd={false}
						value={names.confirmation}
						autocomplete="off"
						update={handleUpdate}
						errors={errors}
					/>
				) : (
					<div className="empty" />
				)}
			</div>

			{names.newStatus === 3 && (
				<div
					className="form-group one"
					style={{ marginTop: "0", marginBottom: "0" }}
				>
					<table
						className="approved bulk"
						style={{ marginTop: "5px", marginBottom: "15px" }}
					>
						<thead>
							<tr>
								<ThDayHdg d="S" />
								<ThDayHdg d="M" />
								<ThDayHdg d="T" />
								<ThDayHdg d="W" />
								<ThDayHdg d="T" />
								<ThDayHdg d="F" />
								<ThDayHdg d="S" />
								<ThDayHdg d="S" />
								<ThDayHdg d="M" />
							</tr>
						</thead>
						<tbody>
							<tr>
								<TdDayVal2 value="sun1" status={details.sun1} />
								<TdDayVal2 value="mon1" status={details.mon1} />
								<TdDayVal2 value="tue1" status={details.tue1} />
								<TdDayVal2 value="wed1" status={details.wed1} />
								<TdDayVal2 value="thu1" status={details.thu1} />
								<TdDayVal2 value="fri1" status={details.fri1} />
								<TdDayVal2 value="sat1" status={details.sat1} />
								<TdDayVal2 value="sun2" status={details.sun2} />
								<TdDayVal2 value="mon2" status={details.mon2} />
							</tr>
						</tbody>
					</table>
				</div>
			)}

			<div className="form-group">
				<Select
					name="bed"
					label="Bed"
					reqd={true}
					value={names.bed}
					options={[
						{ id: "", name: "--" },
						{ id: "nopref", name: "No Preference" },
						{ id: "king", name: "1 King Bed" },
						{ id: "double", name: "2 Queen Beds" },
						{ id: "suite", name: "Suite" },
						{ id: "executive", name: "Executive Suite" },
						{ id: "luxury", name: "Luxury Suite" },
						{ id: "grandriver", name: "Grand River Suite" },
					]}
					update={handleUpdate}
					error={isFieldError(errors, "bed")}
					disabled={names.inProcess ? true : false}
				/>

				<div />
			</div>

			<div className="form-group">
				<Input
					name="name"
					label="Name"
					reqd={true}
					value={names.name}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>

				<Input
					name="email"
					label="Email"
					reqd={true}
					value={names.email}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			<div className="form-group one">
				<Input
					name="notes"
					label="Notes (admin use only)"
					reqd={false}
					value={names.notes}
					autocomplete="off"
					update={handleUpdate}
					errors={errors}
				/>
			</div>

			{/* not used per Samantha 3/20/23
      
      details.status !== names.newStatus && (
        <div className="form-group checkbox" style={{ marginTop: "10px" }}>
          <Checkbox
            name="sendEmail"
            label={`Check to send a status changed email to the dashboard manager (${details.registrationEmail})`}
            checked={false}
            click={handleUpdate}
          />
        </div>
      )*/}

			<div className="msg-submit">
				{msg.type && <Msg data={msg} />}

				<div
					className={
						msg.type === "working" || msg.type === "success"
							? "hidden"
							: "submit-container"
					}
				>
					<Submit
						path="/admin/hotel"
						left="Back"
						submit="Submit Room Request Edits"
					/>
				</div>
			</div>

			<p style={{ marginTop: "20px", marginBottom: "0" }}>
				{details.lastUpdated}
			</p>
		</form>
	);
};

export default HotelEditForm;
